import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from './Button';
import Translation from '@s/Translation';
import { backToDefaultLocale } from "../checkout/actions/intl";

class KioskGoBackButton extends Component {
    render() {
        return(
            <div className="kiosk__go-back__container">
                <Button className="kiosk__go-back__button kiosk-modal__button--secondary" onClick={this.goBack}><Translation>{'checkout__start_a_new_order'}</Translation></Button>
            </div>
        )
    }

    goBack = () => {
        this.props.backToDefaultLocale();
        window.history.back();
    }
}

KioskGoBackButton.propTypes = {
}

KioskGoBackButton.defaultProps = {
}

const mapStateToProps = (state, props) => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        backToDefaultLocale,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(KioskGoBackButton)
